import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-object-detected',
  templateUrl: './object-detected.component.html',
  styleUrls: ['./object-detected.component.css']
})
export class ObjectDetectedComponent implements OnInit {
  json = JSON.stringify({ "ocr_lpb": 1, "stopline_y": 750, "traffic_light": { "green": [1762, 405, 1775, 418], "red": [1764, 350, 1777, 363]}}, undefined, 4)
  json_input;
  constructor() { }

  ngOnInit(): void {
  }
  changeJson() {
    this.json_input = this.json;
  }

}
